import React, {forwardRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {favouritesAssessments, saveAgylePreference} from '../../../../store/reducers/preferences';
import {FormLabel, IconButton} from '@mui/material';
import {useTranslation} from 'react-i18next';
import AgyleDictionaryField from '../../../ui/selector/agyleDictionaryField';
import {agyleAssessmentList} from '../../../../store/reducers/dicts';
import _ from 'lodash';
import {useSettingsStyles} from '../userProperties';
import ClearIcon from '@mui/icons-material/Clear';
import {setSnackbar} from '../../../../store/reducers/globals';

const FavAssessmentsCards = forwardRef((props, ref) => {
    const classes = useSettingsStyles();
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const favAssessments = useSelector(favouritesAssessments);
    const assessmentList = useSelector(agyleAssessmentList);

    const handleAddAssessment = (assessment) => {
        const clone = _.cloneDeep(favAssessments) || [];
        const index = _.findIndex(clone, ass => ass === assessment?.code);
        if (index === -1) {
            clone.push(assessment.code);
        }
        dispatch(saveAgylePreference({favouritesAssessments: clone}));
        dispatch(setSnackbar({type: 'success', message: t('Assessment added.')}));

    };

    const handleDeleteAssessment = (code) => {
        const clone = _.cloneDeep(favAssessments) || [];
        const index = _.findIndex(clone, ass => ass === code);
        if (index !== -1) {
            clone.splice(index, 1);
        }
        dispatch(saveAgylePreference({favouritesAssessments: clone}));
        dispatch(setSnackbar({type: 'success', message: t('Assessment deleted.')}));
    }

    const renderChip = (ass) => {
        const item = _.find(assessmentList, {code: ass});
        if (!item) return null;

        return (
            <div key={item.code} className={classes.chipContainer}>
                {item.description}

                <IconButton
                    size="small"
                    disableRipple
                    onClick={() => handleDeleteAssessment(ass)}
                >
                    <ClearIcon fontSize="small" className={classes.chipIcon} />
                </IconButton>
            </div>
        )
    }

    return (
        <>
            <div>
                <FormLabel style={{fontSize: 'small'}}>
                    {t('Select Favourites Assessments')}
                </FormLabel>

                <div style={{marginTop: 5}}>
                    <AgyleDictionaryField
                        size="small"
                        label={t('Assessments')}
                        options={assessmentList || []}
                        getOptionLabel={(option) => option.description}
                        value={null}
                        onChange={(_e, newValue) => handleAddAssessment(newValue)}
                        noBorder
                        withBackground={false}
                        paperBackground
                    />
                </div>
            </div>

            <div style={{marginTop: 10, display: 'flex', gap: 10, alignItems: 'center'}}>
                {favAssessments.map((ass) => (
                    renderChip(ass)
                ))}
            </div>
        </>
    );
});

export default FavAssessmentsCards;